import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import useUser from 'hooks/useUser';

const WelcomeWidget = (): JSX.Element => {
  const { user } = useUser();
  const userFirstName = user ? user.name.split(' ')[0] : '';

  return (
    <Card
      sx={{ bgcolor: 'primary.dark', color: 'common.white', height: '100%' }}
    >
      <CardContent sx={{ height: '100%', px: [1, 5] }}>
        <Stack spacing={2} sx={{ height: '100%', maxWidth: 900 }}>
          <Typography fontWeight='bold' variant='h4'>
            Welcome back{userFirstName ? `, ${userFirstName}!` : '!'}
          </Typography>

          <Typography>
            Use your dashboard to navigate quickly to your favourite feeds, see
            recent documentation updates and Brandbank contact information.
          </Typography>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default WelcomeWidget;
